'use client';

import { useTranslation } from 'react-i18next';

import { LandingReachBrandPill } from '@/components/landing/landing-reach-brand-pill';
import { useLanguage } from '@/lib/translation';

export function LandingFooter() {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const year = new Date().getFullYear();

  const mobileKindwayLink = (
    <a
      href="https://kindway.ai"
      target="_blank"
      rel="noopener noreferrer"
      dir="ltr"
      className="text-sm font-semibold text-emerald-700 hover:text-emerald-800 hover:underline dark:text-emerald-400 dark:hover:text-emerald-300"
    >
      {t('landing.footer.mobileKindway')}
    </a>
  );

  return (
    <footer className="border-t border-emerald-100/70 bg-white/90 px-4 pt-3 pb-6 md:py-6 dark:border-emerald-900/60 dark:bg-gray-950/80">
      <div className="mx-auto max-w-4xl">
        <div className="flex flex-col items-center gap-2 md:hidden">
          <div className="flex flex-row flex-wrap items-center justify-center gap-x-3 gap-y-2">
            {isRTL ? (
              <>
                {mobileKindwayLink}
                <LandingReachBrandPill />
              </>
            ) : (
              <>
                <LandingReachBrandPill />
                {mobileKindwayLink}
              </>
            )}
          </div>
          <p className="text-center text-[13px] text-muted-foreground whitespace-nowrap">
            {t('landing.footer.mobileCopyright', { year })}
          </p>
        </div>
        <p className="hidden md:block text-center text-sm text-muted-foreground">
          {t('landing.footer.copyright', { year })}
        </p>
      </div>
    </footer>
  );
}
